import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { FormatBoldOutlineIcon, FormatItalicOutlineIcon } from '@compono/ui-icons';
import { Box } from '../../Box/index.js';
import { useTheme } from '../../hooks/useTheme.js';
import { useEditorContext } from '../EditorContext/EditorContext.js';
import { EditorLinkButtons } from '../EditorLinkButtons/EditorLinkButtons.js';
import { EditorMenuButton } from '../EditorMenuButton/EditorMenuButton.js';

var EditorSelectionMenuButtons = function (props) {
    var editor = useEditorContext().editor;
    var handleStyleProps = useTheme().handleStyleProps;
    var setShowLinkDialog = props.setShowLinkDialog, showLinkDialog = props.showLinkDialog, boxProps = __rest(props, ["setShowLinkDialog", "showLinkDialog"]);
    var forwardProps = handleStyleProps(boxProps, {
        themeKey: "editorSelectionMenu",
    });
    return (jsxs(Box, __assign({}, forwardProps, { children: [jsx(EditorMenuButton, __assign({ label: "Bold", onClick: function () { return editor.chain().focus().toggleBold().run(); }, commandName: "bold", size: "sm" }, { children: jsx(FormatBoldOutlineIcon, {}) })), jsx(EditorMenuButton, __assign({ label: "Italic", onClick: function () { return editor.chain().focus().toggleItalic().run(); }, commandName: "italic", size: "sm" }, { children: jsx(FormatItalicOutlineIcon, {}) })), jsx(EditorLinkButtons, { setShowDialog: setShowLinkDialog, showDialog: showLinkDialog, size: "sm" })] })));
};

export { EditorSelectionMenuButtons };
//# sourceMappingURL=EditorSelectionMenuButtons.js.map
